export default __webpack_public_path__ + "static/media/1892.85765cee.png";